import { FC, ReactElement } from 'react';

import { useParams, useSearchParams } from 'react-router-dom';

import { strapiPreviewKeyParameter } from '../../../entities/@api/Strapi';
import { productVariantSeparator } from '../../../entities/@products/Product/Product';
import { useClientEffect } from '../../../hooks';
import {
    CustomPage,
    NotFoundPage,
    ProductCategoryPage,
    ProductDetailPage,
} from '../../../pages';
import { fetchProductCategorySlugs } from '../../../redux/@products/productCategories/productCategoriesActions';
import { useTypedDispatch, useTypedSelector } from '../../../redux/store';

export const ConnectedOtherPageRenderer: FC = (): ReactElement => {
    const { slug = '', subCategory, subSubCategory } = useParams();
    const [searchParams] = useSearchParams();

    const dispatch = useTypedDispatch();

    const customPageSlugs = useTypedSelector(state => state.customPagesSlice.slugs);

    const productCategoriesIsSuccessful = useTypedSelector(state => state.productCategoriesSlice.isSuccessful);
    const productCategories = useTypedSelector(state => state.productCategoriesSlice.productCategories);

    useClientEffect((): void => {
        if (!productCategoriesIsSuccessful && productCategories.length === 0) {
            dispatch(fetchProductCategorySlugs());
        }
    });

    // Check if slug exists in fetched custom page slugs
    const isCustomPage = customPageSlugs.includes(slug);
    const isCustomPagePreview = searchParams.get(strapiPreviewKeyParameter);

    if (isCustomPage || isCustomPagePreview) {
        return (
            <CustomPage />
        );
    }

    // Check if slug exists in fetched product category slugs
    const productCategorySlugs = productCategories.map(productCategory => productCategory.slug);
    const isProductCategory = productCategorySlugs.includes(slug);

    if (isProductCategory || subCategory || subSubCategory) {
        return (
            <ProductCategoryPage />
        );
    }

    // Check if slug contains the characteristic product variant separator
    const isProductDetail = slug.includes(productVariantSeparator);

    if (isProductDetail) {
        return (
            <ProductDetailPage />
        );
    }

    // Return 404 page if page type is not found
    return (
        <NotFoundPage />
    );
};
